/**
 * <s-header-scroll> marks its closest `<header>` with `data-scrolled` once the
 * page leaves the top, so CSS can swap the wordmark for the logo image.
 * Renders nothing itself; place it anywhere inside the header.
 */
class HeaderScroll extends HTMLElement {
  static THRESHOLD = 24;

  connectedCallback() {
    this.header = this.closest('header');
    if (!this.header) return;
    this.ticking = false;
    this.onScroll = () => {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => this.update());
    };
    this.update();
    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  disconnectedCallback() {
    if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
  }

  update() {
    this.header.toggleAttribute('data-scrolled', window.scrollY > HeaderScroll.THRESHOLD);
    this.ticking = false;
  }
}

if (!customElements.get('s-header-scroll')) {
  customElements.define('s-header-scroll', HeaderScroll);
}
